var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-list-cell',{attrs:{"type":"date","format":_vm.format,"condensed":_vm.condensed}},[_c('core-date',{attrs:{"date":_vm.value,"invalid":"n/a"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }